'use client'
import { type CSSProperties, memo } from 'react'

import { ErrorDataUnavailable } from '@/components/common/Error'
import { SubSectionTitle } from '@/components/common/SubSectionTitle'

export interface VaultTableErrorProps {
  title: string
  tableHeight?: CSSProperties['height']
}

const VaultTableError = ({ title, tableHeight = '378px' }: VaultTableErrorProps) => {
  return (
    <div className="gap-sm flex flex-col">
      <SubSectionTitle>{title}</SubSectionTitle>
      <ErrorDataUnavailable minHeight={tableHeight} />
    </div>
  )
}

export default memo(VaultTableError)
